module.exports = require("./ta-SG.d.ts");